module.exports = __webpack_public_path__ + "img/logo.64b9e0b6.png";